// extracted by css-extract-rspack-plugin
export default {"footer":"footer--lNdazRO_GdYf1DAC"};